import React from "react";
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Grid, Button, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { api } from "../../services/api";
import { useParams } from "react-router-dom";
import { format, parseISO } from "date-fns";
import { ManagerContext } from "../../context/ManagerContext";


const ReceiptTemplate = ({ receiptData }) => {
    const { manager } = React.useContext(ManagerContext);
    const { payerName, payerCNPJ, documentLabel = 'CNPJ', status, paymentForm, payerSubcriber, payerAddress, paymentDetails = [], totalAmount, date, eventName, eventLocation, paymentDate, externalId } = receiptData;
   

    const emitterName = manager?.social_reason || manager?.fantasy || "Não informado";
    const emitterCNPJ = manager?.document || "Não informado";
    const isPaid = status === "PAGO" || status === "CORTESIA";
    const isSemper = window.location.pathname.split('/').filter(Boolean)[0] === 'semper';

    console.log(receiptData)

    return (
        receiptData && <>
            <Box sx={{ maxWidth: 800, margin: "auto", padding: 2 }}>
                <Box sx={{ display: "flex", justifyContent: "center", marginBottom: 2 }}>
                    {manager?.logo_url && <img src={manager.logo_url} alt="Logo" style={{ maxWidth: "100%", height: "auto" }} />}
                </Box>
                <Paper elevation={0} sx={{ padding: 3 }}>
                    <Typography variant="h5" align="center" gutterBottom>
                        {isPaid ? 'Recibo de Pagamento' : 'Comprovante de Inscrição'} - N°: {externalId}
                    </Typography>
                    {!isPaid && (
                        <Alert severity="info" sx={{ mb: 2 }}>
                            Esta inscrição ainda não está paga. O status atual do pagamento é: <strong>{status || 'Não informado'}</strong>.
                        </Alert>
                    )}
                    <Box sx={{ marginBottom: 2 }}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Emissor:
                        </Typography>
                        <Typography>{emitterName}  <br/> CNPJ: {emitterCNPJ} </Typography>

                        <Typography variant="subtitle1" fontWeight="bold">
                          Pagador:
                        </Typography>
                        <Typography>{payerName}  <br/> {documentLabel}: {payerCNPJ || 'Não informado'} <br/> Endereço: {payerAddress || 'Não informado'}</Typography>
                        
                        <Typography variant="subtitle1" fontWeight="bold">
                            Nome do Inscrito:
                        </Typography>
                        <Typography>{payerSubcriber}</Typography>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Nome do Evento:
                        </Typography>
                        <Typography>{eventName}</Typography>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Local do Evento:
                        </Typography>
                        <Typography>{eventLocation}</Typography>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Status do Pagamento:
                        </Typography>
                        <Typography>{status || 'Não informado'}</Typography>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Forma de Pagamento:
                        </Typography>
                        <Typography>{paymentForm || 'Não informado'}</Typography>
                    </Box>
                    <TableContainer>
                        <Table size="small">
                            <TableBody>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: "bold" }}>Tipo de Inscrição</TableCell>
                                    <TableCell sx={{ fontWeight: "bold" }}>Quantidade</TableCell>
                                    <TableCell sx={{ fontWeight: "bold" }}>Valor Unitário</TableCell>
                                    <TableCell sx={{ fontWeight: "bold" }}>Subtotal</TableCell>
                                </TableRow>
                                {paymentDetails.map((detail, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{detail.description || 'Inscrição'}</TableCell>
                                        <TableCell>{detail.quantity || 1}</TableCell>
                                        <TableCell>{status !== "CORTESIA" ? Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(detail.unitPrice ?? detail.price ?? totalAmount ?? 0)) : "CORTESIA"}</TableCell>
                                        <TableCell>{status !== "CORTESIA" ? Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(detail.quantity || 1) * Number(detail.unitPrice ?? detail.price ?? totalAmount ?? 0)) : "CORTESIA"}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Box sx={{ marginTop: 2 }}>
                        <Grid container justifyContent="flex-end">
                            <Grid item xs={6}>
                                <Typography variant="subtitle1" fontWeight="bold">
                                    Total:
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="subtitle1" align="right">
                                    {status !== "CORTESIA" ? Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(totalAmount) : "CORTESIA"}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                    {/* Datas*/}
                    <Box sx={{ marginTop: 2, flex: 1, flexDirection: "row", alignItems: "flex-end" }}>
                        {(!isSemper || status === "PAGO") && (
                            <Typography variant="body2" align="right">
                                Data do Pagamento: {paymentDate}
                            </Typography>
                        )}
                        {(!isSemper) && (
                            <Typography variant="body2" align="right">
                                Data do Recibo: {paymentDate || date}
                            </Typography>
                        )}
                    </Box>
                </Paper>
                <Box sx={{ marginTop: 2, textAlign: "center" }}>
                    {manager?.fantasy === 'APEPREV' ? (
                        <>
                            <img src="/bolecode/ass.png" alt="Assinatura" width={140} style={{ "transform": "rotate(22deg)", "margin-top": '-20px' }} />
                            <Typography variant="body2" sx={{ marginTop: -4, textDecoration: "overline" }}>
                                Presidente da Apeprev
                            </Typography>
                        </>
                    ) : null}
                    <Button id="print" variant="contained" sx={{ marginTop: 2 }} onClick={() => {
                        document.getElementById("print").style.visibility = "hidden";
                        window.print()
                        document.getElementById("print").style.visibility = "visible";
                    }}
                    >
                        {isSemper ? 'Imprimir somente' : 'Imprimir Recibo'}
                    </Button>
                </Box>
            </Box>
        </>
    );
};
export default function Recibo() {
    const [receiptData, setReceiptData] = React.useState("");
    const { externalId } = useParams();
    const [error, setError] = React.useState(false)
    const navigate = useNavigate(); 

    React.useEffect(() => {
        async function loadData() {
            try {
                console.log(externalId)
                const response = await api.get(`/order/boleto/${externalId}`)
                console.log(response)
                // Verifica se é um boleto de filiação (possui campo affiliate)
                if (response.data.affiliate) {
                    await loadRecipeAffiliate(response)
                } else {
                    await loadRecipe(response)
                }

            } catch (error) {
                setError(true)
                console.log(error)

            }
        }

        async function loadRecipeAffiliate(response) {
            const { total, affiliate, updatedAt, paymentDate, external_id, reference, status, payment_form } = response.data
            const company = affiliate.company || {}

            // tenta extrair o objeto pagador de possíveis caminhos no payload
            const pagador = response.data.pagador
                || response.data.dado_boleto?.pagador
                || response.data.boleto?.data?.dado_boleto?.pagador
                || response.data.bolecode?.data?.dado_boleto?.pagador
                || response.data.bolecode?.dado_boleto?.pagador
                || response.data.affiliate?.boleto?.data?.dado_boleto?.pagador
                || null

            const pessoaNome = pagador?.pessoa?.nome_pessoa || company.social_reason || 'N/A'
            const endereco = pagador?.endereco || {}
            const enderecoParts = []
            if (endereco.nome_logradouro) enderecoParts.push(endereco.nome_logradouro)
            if (endereco.numero) enderecoParts.push(endereco.numero)
            if (endereco.nome_bairro) enderecoParts.push(endereco.nome_bairro)
            const cidadeUf = `${endereco.nome_cidade || company.city || ''}${endereco.sigla_UF ? ' - ' + endereco.sigla_UF : company.state ? ' - ' + company.state : ''}`.trim()
            const cep = endereco.numero_CEP || endereco.cep || company.cep || ''
            const fullAddress = `${enderecoParts.join(', ')}${enderecoParts.length ? ', ' : ''}${cidadeUf}${cep ? ' - CEP: ' + cep : ''}`

            setReceiptData({
                eventName: `Filiação APEPREV - ${reference}`,
                eventLocation: 'Curitiba - PR',
                payerName: pessoaNome,
                documentLabel: 'CNPJ',
                payerAddress: fullAddress || `${company.address || ''}, ${company.city || ''}/${company.state || ''} - CEP: ${company.cep || ''}`,
                payerSubcriber: pessoaNome,
                paymentDetails: [
                    { description: `Anuidade ${reference}`, price: total, quantity: 1, unitPrice: total },
                ],
                externalId: external_id,
                totalAmount: total,
                status,
                paymentForm: payment_form,
                date: new Date().toLocaleDateString(),
                paymentDate: paymentDate ? format(parseISO(paymentDate), "dd/MM/yyyy") : format(parseISO(response.data.payment_date), "dd/MM/yyyy") || new Date(updatedAt).toLocaleDateString(),
            });
        }

        async function loadRecipe(response) {
            const { subscribers = [], total = 0, company, event = {}, plan = {}, updatedAt, paymentDate, external_id, status, payment_form } = response.data
            const subscriber = subscribers[0] || {}
            const payerDocument = company?.document || subscriber.document || ''
            const payerName = company?.social_reason || subscriber.name || subscriber.badge || 'Não informado'
            const payerAddress = company
                ? `${company.address || ''}, ${company.city || ''}/${company.state || ''} - CEP: ${company.cep || ''}`
                : `${subscriber.street || ''}, ${subscriber.number || ''} - ${subscriber.neighborhood || ''}, ${subscriber.city || ''}/${subscriber.state || ''} - CEP: ${subscriber.cep || ''}`
            const paymentDateValue = paymentDate || response.data.payment_date || updatedAt

            setReceiptData({
                eventName: event.name || 'Evento não informado',
                eventLocation: event.city || event.location_address || 'Local não informado',
                payerName,
                payerCNPJ: payerDocument,
                documentLabel: company ? 'CNPJ' : 'CPF',
                payerAddress, 
                payerSubcriber: `${subscriber.name || payerName}${subscriber.document ? ` | CPF: ${subscriber.document}` : ''}`,
                paymentDetails: [
                    { description: plan.type || 'Inscrição', price: plan.price || total, quantity: 1, unitPrice: total },
                ],
                externalId: external_id,
                totalAmount: total,
                status,
                paymentForm: payment_form,
                date: new Date().toLocaleDateString(),
                paymentDate: paymentDateValue ? format(new Date(paymentDateValue), "dd/MM/yyyy") : '',
            });
        };

        loadData()


    }, [externalId]);

    if (receiptData === "") {
        return <div>Carregando...</div>;
    }
    if (error) {
        return (
            <Box sx={{ maxWidth: 800, margin: "0 auto", padding: 20 }}>
                <Typography variant="h5" align="center" gutterBottom>
                    Verifique se o pedido de Inscrição está com status PAGO.
                </Typography>
                <Button variant="outlined" fullWidth onClick={() => navigate(-1)}>Voltar</Button>
            </Box>
        )
    }
    return <ReceiptTemplate receiptData={receiptData} />;
}